var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4585 47.5598C44.664 47.5598 54.6099 37.6355 54.6099 25.4074C54.6099 13.2013 44.664 3.25488 32.4585 3.25488C20.231 3.25488 10.3071 13.2013 10.3071 25.4074C10.3071 37.4283 19.8974 47.2227 31.8388 47.5513L32.4585 47.5598Z",
    fill: "url(#paint0_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0473 20.3887H36.8647C37.3386 19.8105 37.572 19.0722 37.5167 18.3267C37.4614 17.5811 37.1215 16.8854 36.5674 16.3835C36.0133 15.8817 35.2875 15.6121 34.5402 15.6305C33.7929 15.649 33.0813 15.9542 32.5527 16.4828C32.3419 16.7025 32.168 16.9549 32.0379 17.2302C31.9077 16.9549 31.7338 16.7025 31.523 16.4827C30.9944 15.9541 30.2828 15.649 29.5355 15.6305C28.7881 15.6121 28.0623 15.8817 27.5083 16.3836C26.9542 16.8854 26.6144 17.5811 26.559 18.3267C26.5037 19.0722 26.7371 19.8105 27.211 20.3887H24.0284C23.6423 20.3891 23.2722 20.5427 22.9992 20.8157C22.7261 21.0887 22.5726 21.4589 22.5721 21.845V24.7577C22.5726 25.1438 22.7261 25.5139 22.9992 25.787C23.2722 26.06 23.6423 26.2136 24.0284 26.214V32.0393C24.0289 32.4255 24.1824 32.7956 24.4554 33.0686C24.7284 33.3417 25.0986 33.4952 25.4847 33.4957H38.5911C38.9772 33.4952 39.3473 33.3417 39.6203 33.0686C39.8933 32.7956 40.0469 32.4255 40.0473 32.0393V26.214C40.4334 26.2136 40.8036 26.06 41.0766 25.787C41.3496 25.5139 41.5032 25.1438 41.5036 24.7577V21.845C41.5032 21.4589 41.3496 21.0887 41.0766 20.8157C40.8036 20.5427 40.4334 20.3891 40.0473 20.3887ZM33.5824 17.5126C33.7176 17.3773 33.8782 17.27 34.0549 17.1967C34.2316 17.1235 34.4209 17.0858 34.6122 17.0858C34.8035 17.0857 34.9929 17.1234 35.1696 17.1966C35.3463 17.2698 35.5069 17.377 35.6422 17.5123C35.7774 17.6476 35.8847 17.8081 35.9579 17.9849C36.0311 18.1616 36.0687 18.351 36.0687 18.5423C36.0687 18.7336 36.031 18.923 35.9578 19.0997C35.8845 19.2764 35.7772 19.4369 35.6419 19.5722C35.1923 20.0219 33.8921 20.2745 32.797 20.3576C32.8802 19.2624 33.1327 17.9623 33.5824 17.5126ZM28.4337 17.5126C28.7071 17.2399 29.0774 17.0867 29.4635 17.0867C29.8496 17.0867 30.2199 17.2399 30.4933 17.5126C30.943 17.9623 31.1955 19.2626 31.2787 20.3576C30.1836 20.2744 28.8835 20.0219 28.4338 19.5722C28.1611 19.2988 28.008 18.9285 28.008 18.5424C28.008 18.1563 28.1611 17.7859 28.4337 17.5126ZM40.0473 24.7577H32.766V31.3112C32.766 31.5043 32.6893 31.6895 32.5527 31.8261C32.4162 31.9626 32.231 32.0393 32.0379 32.0393C31.8448 32.0393 31.6596 31.9626 31.523 31.8261C31.3865 31.6895 31.3097 31.5043 31.3097 31.3112V24.7577H24.0284V21.845H31.3097V24.7577H32.766V21.845H40.0473L40.0482 24.7576L40.0473 24.7577Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -7.57367,
    y: -14.6259,
    width: 80.0644,
    height: 80.0665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.9404
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.28118 7.64558) rotate(54.4636) scale(72.0341 72.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF196E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF196E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7cb74a565383bb072051f9b7d9524358.svg";
export { ForwardRef as ReactComponent };